import newOrderSoundSrc from 'static/audio/new-order.mp3';

export function playNewOrderSound() {
  if (typeof Audio === 'undefined') return;

  const playPromise = new Audio(newOrderSoundSrc).play();
  if (playPromise?.catch) {
    playPromise.catch(() => {
      // Browser autoplay policy blocks audio until the user first interacts with the page.
    });
  }
}
